
import { AnimatePresence } from "framer-motion";
import { GridViewEntry } from "./GridViewEntry";
import { JournalEntry } from "./types";

interface EntriesGridViewProps {
  entries: JournalEntry[];
  onLike: (id: string) => void;
  onDelete: (id: string) => void;
}

export const EntriesGridView = ({ entries, onLike, onDelete }: EntriesGridViewProps) => {
  return (
    <div className="grid gap-6 md:grid-cols-2">
      <AnimatePresence>
        {entries.map((entry) => (
          <GridViewEntry 
            key={entry.id} 
            entry={entry} 
            onLike={onLike} 
            onDelete={onDelete} 
          />
        ))}
      </AnimatePresence>
    </div>
  );
};
